<template>
  <ResourceDialog
    @save="$emit('save', $event)"
    ref="dialog"
    :fields="fields"
    :max-width="600"
    :processing="processing"
    :save-button-disabled-function="invalidBankAccount"
    save-button-text="Update"
    title="Update bank account details"
    close-on-save
  />
</template>

<script setup>
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';

const $bct = inject('translator');

const props = defineProps({
  attestationDescription: {
    type: String,
    default: null,
  },
  processing: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['save']);

defineExpose({ open });

const dialog = ref(null);

const fields = computed(() => {
  const fieldsArray = [
    {
      text: 'Routing number',
      description:
        'The 9-digit number on your check identifies your bank and tells us where to find your account.',
      value: 'bank_routing_number',
      mask: '#########',
      required: true,
    },
    {
      text: 'Account number',
      value: 'bank_account_number',
      mask: '####################',
      required: true,
    },
    {
      text: 'Account type',
      value: 'bank_account_type',
      items: ['Checking', 'Savings'],
      required: true,
      itemText: (item) => $bct(item),
      itemValue: (item) => item,
    },
    {
      text: 'Account nickname',
      description: 'Add a nickname so you can identify your account.',
      value: 'bank_account_name',
      required: true,
    },
  ];

  if (props.attestationDescription) {
    fieldsArray.push({
      text: 'Attestation',
      description: props.attestationDescription,
      checkboxText: 'I agree',
      value: 'attestation',
      type: 'boolean',
      required: true,
    });
  }

  return fieldsArray;
});

function invalidBankAccount(localValue) {
  return !(
    (localValue.bank_routing_number?.length || 0) === 9 &&
    (localValue.bank_account_number?.length || 0) > 6 &&
    localValue.bank_account_name &&
    localValue.bank_account_type &&
    (!props.attestationDescription || localValue.attestation === true)
  );
}

function open() {
  dialog.value.open({ attestation: false });
}
</script>
